import SiteFooter from "@/components/SiteFooter";

const ImpressumPage = () => {
  return (
    <div className="page-shell" data-testid="impressum-page">
      <main className="legal-main" data-testid="impressum-main-content">
        <h1 className="legal-title" data-testid="impressum-title">
          Impressum
        </h1>

        <h2 className="legal-section-title" data-testid="impressum-section-verantwortlich">
          Verantwortlich für Angebot und Inhalt dieser Website:
        </h2>
        <p className="legal-text" data-testid="impressum-contact-address">
          Art of Life
          <br />
          Gabriele Sauer
          <br />
          Spargasse 8
          <br />
          97688 Bad Kissingen
          <br />
          Tel. 0971 13 19 13 88
          <br />
          Mobil: 0176 20 19 79 60
          <br />
          E-Mail: info@gabriele-sauer-reiki.de
        </p>

        <p className="legal-text" data-testid="impressum-membership">
          aktives Mitglied im Berufsverband ProReiki
        </p>

        <p className="legal-text" data-testid="impressum-tax-number">
          Steuer-Nummer:
          <br />
          155 / 265 / 04108
        </p>

        <h2 className="legal-section-title" data-testid="impressum-section-onlineangebot">
          Inhalt des Onlineangebotes
        </h2>
        <p className="legal-text" data-testid="impressum-onlineangebot-p1">
          Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit
          oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor,
          welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung
          oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und
          unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern
          seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden
          vorliegt.
        </p>
        <p className="legal-text" data-testid="impressum-onlineangebot-p2">
          Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich
          vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern,
          zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
        </p>

        <h2 className="legal-section-title" data-testid="impressum-section-links">
          Verweise und Links
        </h2>
        <p className="legal-text" data-testid="impressum-links-p1">
          Bei direkten oder indirekten Verweisen auf fremde Webseiten ("Hyperlinks"), die
          außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung
          ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis
          hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger
          Inhalte zu verhindern.
        </p>
        <p className="legal-text" data-testid="impressum-links-p2">
          Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine
          illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und
          zukünftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verknüpften
          Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich
          von allen Inhalten aller verlinkten /verknüpften Seiten, die nach der Linksetzung
          verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes
          gesetzten Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten
          Gästebüchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen anderen
          Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe möglich sind. Für
          illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus
          der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet
          allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über
          Links auf die jeweilige Veröffentlichung lediglich verweist.
        </p>

        <h2 className="legal-section-title" data-testid="impressum-section-urheberrecht">
          Urheber- und Kennzeichenrecht
        </h2>
        <p className="legal-text" data-testid="impressum-urheberrecht-p1">
          Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Bilder,
          Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte
          Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie
          Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.
        </p>
        <p className="legal-text" data-testid="impressum-urheberrecht-p2">
          Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken-
          und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen
          Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein
          aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht
          durch Rechte Dritter geschützt sind!
        </p>
        <p className="legal-text" data-testid="impressum-urheberrecht-p3">
          Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim
          Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente,
          Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne
          ausdrückliche Zustimmung des Autors nicht gestattet.
        </p>

        <h2 className="legal-section-title" data-testid="impressum-section-datenschutz">
          Datenschutz
        </h2>
        <p className="legal-text" data-testid="impressum-datenschutz-p1">
          Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder
          geschäftlicher Daten (Emailadressen, Namen, Anschriften) besteht, so erfolgt die
          Preisgabe dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die
          Inanspruchnahme und Bezahlung aller angebotenen Dienste ist - soweit technisch möglich und
          zumutbar - auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder
          eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer
          Angaben veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie
          Emailadressen durch Dritte zur Übersendung von nicht ausdrücklich angeforderten
          Informationen ist nicht gestattet. Rechtliche Schritte gegen die Versender von sogenannten
          Spam-Mails bei Verstössen gegen dieses Verbot sind ausdrücklich vorbehalten.
        </p>

        <h2 className="legal-section-title" data-testid="impressum-section-rechtswirksamkeit">
          Rechtswirksamkeit dieses Haftungsausschlusses
        </h2>
        <p className="legal-text" data-testid="impressum-rechtswirksamkeit-p1">
          Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus
          auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes
          der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten,
          bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon
          unberührt.
        </p>
      </main>

      <SiteFooter />
    </div>
  );
};

export default ImpressumPage;